import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as API from "./api";
import * as Actions from "./actions";

function* loadCDistrictsHandler() {
  try {
    const { response } = yield call(API.loadDistricts);
    yield put(Actions.loadDistricts.success(response));
  } catch (error) {
    yield put(Actions.loadDistricts.failure(error));
  }
}

function* watchLoadDistricts() {
  yield takeLatest(Actions.LOAD_DISTRICTS.REQUEST, loadCDistrictsHandler);
}

export default function* districtsSagas() {
  yield all([fork(watchLoadDistricts)]);
}
